import { render, staticRenderFns } from "./AjaxRegister.vue?vue&type=template&id=886f99e2"
import script from "./AjaxRegister.vue?vue&type=script&lang=js"
export * from "./AjaxRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports